export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map - Volvelle.4ddc122c.mp4";